import http from './httpClient';

export const login = async (username, password) => {
  const result = await http.post('/api-token-auth/', {
    username,
    password,
  });
  return result;
};
